import db, { storage, auth } from '../../../firebase/firebase'
import { db1, storage1, auth1 } from '../../../firebase/firebase1'
import firebase from "firebase/compat/app"
import moment from 'moment'
import showToast from '../../../util/toast'

const Api = {

    getQuizzes: (success, error) => {
        db1.collection("quizzes")
            .get()
            .then(querySnapshot => {
                let models = [];
                for (let i = 0; i < querySnapshot.docs.length; i++) {
                    const doc = querySnapshot.docs[i];
                    const data = doc.data();
                    data.id = doc.id;
                    models.push(data);
                }
                models.sort((a, b) => b.added_date - a.added_date);
                success(models);
            })
            .catch(() => error('Load failed!'));
    },

    deleteQuiz: (id) => {
        db1.collection("quizzes").doc(id).delete();
    },

    getMedicalTidbits: (success, error) => {
        db1.collection("medical_tidbits")
            .get()
            .then(querySnapshot => {
                let models = []
                for (let i = 0; i < querySnapshot.docs.length; i++) {
                    const doc = querySnapshot.docs[i];
                    const data = doc.data()
                    data.id = doc.id
                    models.push(data)
                }
                models.sort((a, b) => b.added_date - a.added_date)
                success(models)
            })
            .catch(e => {
                error('Load failed!')
            });
    },

    deleteMedicalTidbit: (id) => {
        db1.collection("medical_tidbits")
            .doc(id)
            .delete()
    },

    deleteMindArticle: (id) => {
        db1.collection("mind_articles")
            .doc(id)
            .delete()
    },

    getMindArticles: (success, error) => {
        db1.collection("mind_articles")
            .get()
            .then(querySnapshot => {
                // const models = querySnapshot.docs.map(doc => doc.data());
                // models.sort((a, b) => b.added_date - a.added_date)
                let models = []
                for (let i = 0; i < querySnapshot.docs.length; i++) {
                    const doc = querySnapshot.docs[i];
                    const data = doc.data()
                    data.id = doc.id
                    models.push(data)
                }
                models.sort((a, b) => b.added_date - a.added_date)
                success(models)
            })
            .catch(e => {
                error('Load failed!')
            });
    },

    deleteRecipe: (id) => {
        db1.collection("recipes")
            .doc(id)
            .delete()
    },

    getRecipeOfWeek: (success, error) => {
        db1.collection("recipeOfWeek")
            .doc('recipeOfWeek')
            .get()
            .then(doc => {
                // console.log('data: '+JSON.stringify(doc.data));
                success(doc.data().recId)
            })
            .catch(e => {
                error('Load failed!')
            });
    },

    getRecipes: (success, error) => {
        db1.collection("recipes")
            .get()
            .then(querySnapshot => {
                // const models = querySnapshot.docs.map(doc => doc.data());
                // models.sort((a, b) => b.added_date - a.added_date)
                let models = []
                for (let i = 0; i < querySnapshot.docs.length; i++) {
                    const doc = querySnapshot.docs[i];
                    const data = doc.data()
                    data.id = doc.id
                    models.push(data)
                }
                models.sort((a, b) => b.added_date - a.added_date)
                success(models)
            })
            .catch(e => {
                error('Load failed!')
            });
    },

    deleteProduct: (model, success) => {
        // firestore delete
        db1.collection("our_products")
            .doc(model.id)
            .delete()
            .then(() => {
                success()
            })
    },

    getProducts: (success, error) => {
        db1.collection("our_products")
            .get()
            .then(querySnapshot => {
                // const models = querySnapshot.docs.map(doc => doc.data());
                // models.sort((a, b) => b.added_date - a.added_date)
                let models = []
                for (let i = 0; i < querySnapshot.docs.length; i++) {
                    const doc = querySnapshot.docs[i];
                    const data = doc.data()
                    data.id = doc.id
                    models.push(data)
                }
                models.sort((a, b) => b.added_date - a.added_date)
                success(models)
            })
            .catch(e => {
                error('Load failed!')
            })
    },

    deleteAffiliate: (model, success) => {
        // firestore delete
        db1.collection("products")
            .doc(model.id)
            .delete()
            .then(() => {
                success()
            })
    },

    getAffiliates: (success, error) => {
        db1.collection("products")
            .get()
            .then(querySnapshot => {
                let models = []
                for (let i = 0; i < querySnapshot.docs.length; i++) {
                    const doc = querySnapshot.docs[i];
                    const data = doc.data()
                    data.id = doc.id
                    models.push(data)
                }
                models.sort((a, b) => b.added_date - a.added_date)
                success(models)
            })
            .catch(e => {
                error('Load failed!')
            })
    },

    deleteDoctor: (model, success) => {
        // auth delete
        db.collection("deleteUserCache")
            .add({
                id: model.id,
                email: model.email
            })
        // firestore delete
        db.collection("doctors")
            .doc(model.id)
            .delete()
            .then(() => {
                success()
            })
    },

    //deleteUserCache
    deletePatient: (model, success) => {
        // auth delete
        db.collection("deleteUserCache")
            .add({
                id: model.id,
                email: model.email
            })
        // firestore delete
        db.collection("patients")
            .doc(model.id)
            .delete()
            .then(() => {
                success()
            })
    },

    deleteVideo: (id) => {
        db1.collection("videos")
            .doc(id)
            .delete()
    },

    getVideos: (success, error) => {
        db1.collection("videos")
            .get()
            .then(querySnapshot => {
                // const models = querySnapshot.docs.map(doc => doc.data());
                // models.sort((a, b) => b.added_date - a.added_date)
                let models = []
                for (let i = 0; i < querySnapshot.docs.length; i++) {
                    const doc = querySnapshot.docs[i];
                    const data = doc.data()
                    data.id = doc.id
                    models.push(data)
                }
                models.sort((a, b) => b.added_date - a.added_date)
                success(models)
            })
            .catch(e => {
                console.log('err', e);
                error('Load failed!')
            });
    },

    deleteArticle: (id) => {
        db.collection("articles")
            .doc(id)
            .delete()
    },

    getArticles: (success, error) => {
        db.collection("articles")
            .get()
            .then(querySnapshot => {
                // const models = querySnapshot.docs.map(doc => doc.data());
                // models.sort((a, b) => b.added_date - a.added_date)
                let models = []
                for (let i = 0; i < querySnapshot.docs.length; i++) {
                    const doc = querySnapshot.docs[i];
                    const data = doc.data()
                    data.id = doc.id
                    models.push(data)
                }
                models.sort((a, b) => b.added_date - a.added_date)
                success(models)
            })
            .catch(e => {
                error('Load failed!')
            });
    },

    signupDoctor: async (doctor, password, success, error) => {
        console.log('doctor: ' + JSON.stringify(doctor));
        auth.createUserWithEmailAndPassword(doctor.email, password)
            .then(() => {
                console.log('User signup success');
                // create user in firestore
                db.collection('doctors')
                    .add(doctor)
                    .then((doc) => {
                        console.log(doc.id);
                        console.log('User added success');
                        success(doc.id)
                    })
                    .catch(e => {
                        error(e.message)
                        console.log(e.message);
                    });
            })
            .catch(e => {
                error(e.message)
                console.log(e.message);
            });
    },

    login: (email, password, success, error) => {
        auth.signInAnonymously()
            .then(() => {
                console.log('signedInAnonymously');
                db.collection("admin")
                    .where("email", "==", email)
                    .where("password", "==", password)
                    .get()
                    .then(querySnapshot => {
                        const data = querySnapshot.docs.map(doc => doc.data());
                        if (data.length > 0) {
                            let user = data[0];
                            success(user)
                        }
                        else {
                            error('Could not login')
                        }
                    });
            })
            .catch((error) => {
                error('Could not login')
            });
    },

    updateAdmin: (email, password, success, error) => {
        db.collection('admin')
            .doc('admin')
            .set({
                email: email,
                password: password,
                updated_on: firebase.firestore.FieldValue.serverTimestamp()
            }, { merge: true })
            .then(() => {
                success()
            })
            .catch(e => {
                error('Update failed!')
            });
    },

    updateWithdrawalStatus: (docId, status, success, error) => {
        db.collection("withdrawals")
            .doc(docId)
            .set({ status: status }, { merge: true })
            .then(() => {
                success()
            })
            .catch(e => {
                error('Load failed!')
            });
    },

    getWithdrawals: (success, error) => {
        db.collection("withdrawals")
            .get()
            .then(querySnapshot => {
                const models = querySnapshot.docs.map(doc => doc.data());
                models.sort((a, b) => b.added_date - a.added_date)
                success(models)
            })
            .catch(e => {
                error('Load failed!')
            });
    },

    getPatients: (success, error) => {
        db.collection("patients")
            .get()
            .then(querySnapshot => {
                let models = []
                for (let i = 0; i < querySnapshot.docs.length; i++) {
                    const doc = querySnapshot.docs[i];
                    let model = doc.data()
                    model.id = doc.id
                    models.push(model)
                }
                models.sort((a, b) => b.added_date - a.added_date)
                success(models)
            })
            .catch(e => {
                error('Load failed!')
            })
    },

    getDoctors: (success, error) => {
        db.collection("doctors")
            .get()
            .then(querySnapshot => {
                let models = []
                for (let i = 0; i < querySnapshot.docs.length; i++) {
                    const doc = querySnapshot.docs[i];
                    let model = doc.data()
                    model.id = doc.id
                    models.push(model)
                }
                models.sort((a, b) => b.added_date - a.added_date)
                success(models)
            })
            .catch(e => {
                error('Load failed!')
            })
    },

    getServerTimestamp: (success) => {
        var ref = db.collection('timestamp').doc('timestamp')
        ref.set({ timestamp: firebase.firestore.FieldValue.serverTimestamp() });
        ref.onSnapshot(function (snapshot) {
            var timestamp = snapshot.data().timestamp;
            success(timestamp)
        })
    },

    sendPushToAll: (title, msg, onSuccess, onError) => {
        console.log('sendPushToAll');
        db1.collection('push_logs').add({
            title: title,
            body: msg,
            added_date: firebase.firestore.FieldValue.serverTimestamp()
        })
        .then(() => {
            if (onSuccess) onSuccess();
        })
        .catch(err => {
            console.error('Error adding push log:', err);
            if (onError) onError();
        });
    },

    getScheduledPushes: (success, error) => {
        db1.collection("scheduled_pushes")
            .get()
            .then(querySnapshot => {
                let models = [];
                for (let i = 0; i < querySnapshot.docs.length; i++) {
                    const doc = querySnapshot.docs[i];
                    const data = doc.data();
                    data.id = doc.id;
                    models.push(data);
                }
                models.sort((a, b) => a.scheduledAt - b.scheduledAt);
                success(models);
            })
            .catch(() => {
                if (error) error('Load failed!');
            });
    },

    addScheduledPush: (title, msg, scheduledAt, onSuccess, onError) => {
        db1.collection('scheduled_pushes').add({
            title: title,
            body: msg,
            scheduledAt: scheduledAt,
            status: 'scheduled',
            added_date: parseInt(moment() + '')
        })
        .then(() => {
            if (onSuccess) onSuccess();
        })
        .catch(err => {
            console.error('Error scheduling push:', err);
            if (onError) onError();
        });
    },

    updateScheduledPush: (id, title, msg, scheduledAt, onSuccess, onError) => {
        db1.collection('scheduled_pushes').doc(id).set({
            title: title,
            body: msg,
            scheduledAt: scheduledAt,
            status: 'scheduled'
        }, { merge: true })
        .then(() => {
            if (onSuccess) onSuccess();
        })
        .catch(err => {
            console.error('Error updating scheduled push:', err);
            if (onError) onError();
        });
    },

    deleteScheduledPush: (id) => {
        db1.collection("scheduled_pushes").doc(id).delete();
    },

    updatePatientStatus: (email, status, success, error) => {
        console.log('email: ' + email);
        console.log('status: ' + status);
        db.collection("patients")
            .where("email", "==", email)
            .get()
            .then(querySnapshot => {
                const doc = querySnapshot.docs[0];
                console.log('docID: ' + doc.id);
                db.collection('patients')
                    .doc(doc.id)
                    .set({
                        status: status
                    }, { merge: true })
                    .then(() => {
                        success()
                    })
                    .catch(e => {
                        console.log(e);
                        error('Update failed!')
                    });
            });
    },

    updateStatus: (email, status, success, error) => {
        console.log('email: ' + email);
        console.log('status: ' + status);
        db.collection("doctors")
            .where("email", "==", email)
            .get()
            .then(querySnapshot => {
                const doc = querySnapshot.docs[0];
                console.log('docID: ' + doc.id);
                db.collection('doctors')
                    .doc(doc.id)
                    .set({
                        status: status
                    }, { merge: true })
                    .then(() => {
                        success()
                    })
                    .catch(e => {
                        console.log(e);
                        error('Update failed!')
                    });
            });
    },

    sendVerifiedEmail: (doctor) => {
        console.log('send email: ' + doctor.email);
        // send email
        let mailParams = {
            "accessToken": "J2ECuXpVbXIVT-Yu-P-wC",
            "service_id": "gmail",
            "template_id": "template_dsv6zmg",
            "user_id": "5yIURgbf9PsA9yLIR",
            "template_params": {
                "name": doctor.name,
                "email": doctor.email
            }
        }
        fetch('https://api.emailjs.com/api/v1.0/email/send', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(mailParams)
        })
            .then(response => response.json())
            .then(result => {
                console.log(JSON.stringify(result))
            })
            .catch(err => {
                console.log(err)
            });
    },

    sendContactUsEmail: (obj) => {
        // send email
        let mailParams = {
            "accessToken": "J2ECuXpVbXIVT-Yu-P-wC",
            "service_id": "gmail",
            "template_id": "template_n5tkgn8",
            "user_id": "5yIURgbf9PsA9yLIR",
            "template_params": {
                "name": obj.name,
                "contact": obj.contact,
                "message": obj.message,
            }
        }
        fetch('https://api.emailjs.com/api/v1.0/email/send', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(mailParams)
        })
            .then(response => response.text())
            .then(result => {
                showToast('success', "Thanks for contacting us. Our admin will reply soon.")
            })
            .catch(err => {
                console.log(err)
            });
    },
}

export default Api;
